import {Injectable} from '@angular/core';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {IFilterModel} from '@irb/app.model';
import {AppService} from '@irb/app.service';
import {IDropdownItem} from "@irb-common/models/dropdown.model";

@Injectable({providedIn: 'root'})
export class MorningstarService {
    styles: Array<IDropdownItem> = [
            {name: "Large Growth", value: "Large Growth"},
            {name: "Large Blend", value: "Large Blend"},
            {name: "Large Value", value: "Large Value"},
            {name: "Mid Growth", value: "Mid Growth"},
            {name: "Mid Blend", value: "Mid Blend"},
            {name: "Mid Value", value: "Mid Value"},
            {name: "Small Growth", value: "Small Growth"},
            {name: "Small Blend", value: "Small Blend"},
            {name: "Small Value", value: "Small Value"},
            {name: "Uncategorized", value: "Uncategorized"}
        ];

    constructor(
        private util: UtilityService, 
        private as: AppService
    ) {
        this.styles = this.util.sortByKey(this.styles, 'name', 'asc');
    }

    getMorningstarStyles(parent: any) {        
        parent.params.api.getColumnFilterInstance('styleBoxLabel').then((f: any) => {
            let filterModel: IFilterModel = this.as.getFieldInfo(parent.applyFilterOnLanding, 'styleBoxLabel');

            if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
                filterModel.isUpdatRequired = false;
                parent.applyFilterOnLanding.isUpdatRequired = false;
                
                f.values = f.getIDropdownItems([filterModel.value]);
                parent.params.api.setFilterModel({'styleBoxLabel': { 'values': [filterModel.value]}});
                parent.params.api.onFilterChanged();

                if (!parent.hasServerSideDatasource) {
                    parent.params.api.setGridOption('serverSideDatasource', parent.setDatasource());
                }
            }  
        });   
    }

    getDropdownOptionsForMorningstarStyles() {
        return this.styles;
    }
}